var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#c8cace;stroke-linecap:round;stroke-width:2px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "btn_close_",
    "data-name": "btn_close",
    transform: "translate(-20.997 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "container",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(20.997 7)",
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "translate(22.997 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_3",
    "data-name": "\\uC120 3",
    className: "cls-2",
    d: "m0 0 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_3-2",
    "data-name": "\\uC120 3",
    className: "cls-2",
    transform: "rotate(90 7 7)",
    d: "m0 0 14 14"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btn-close.59f32409b9a1b93e1f5fb4287dff941d.svg";
export { ForwardRef as ReactComponent };